<template>
    <div style="height:100%;overflow-y:hidden">
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">聊天管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">聊天页面</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

 <!-- <div @click="toplay">点击播放</div> -->
        <div class="data-list chatpageall" style="background:none;height:92%">
            <div class="chatpage">
                <div class="top">
                    <img v-if="headimgurl" :src="headimgurl" alt="">
                    <img v-else src="../../../static/head.svg" alt="">
                    <div >
                        <h2 v-if="nickname">{{nickname}}</h2>
                        <h2 v-else>暂无接入</h2>
                        <a-tooltip v-if="khinfo.introduction" placement="right">
                            <template slot="title">
                            <span>{{khinfo.introduction}}</span>
                            </template>
                            <p class="kfinfo">
                                <span>{{khinfo.introduction}} </span> 
                                <span>显示更多</span>
                            </p>
                        </a-tooltip>
                    </div>

                
                </div>
                <div class="middle" id="chatRecord">
                    <ul v-if="chatloglist">
                        <div v-for="item,i in chatloglist" :key="i">
                            <li v-if="item.opercode==2003">
                                <div class="avatr"><img src="../../../static/head.svg" alt=""></div>
                                <div >
                                    <p>{{item.addtime | showDate}}</p>
                                    <div v-if="item.MsgType=='image'" class="chattext">
                                         <img @click="tobig(item.PicUrl)" v-viewer="{movable: false}" class="pictur" :src="item.PicUrl" alt="">
                                    </div>
                                    <div v-if="item.MsgType=='text'" class="chattext">
                                        {{item.content}}
                                    </div>

                                    <div v-if="item.MsgType=='voice'" class="chattext">
                                        <div class="voice-bg" @click="toplay(item.voiceUrl,i)">
                                            <img
                                                :src="item.isPlaying==1 ? '../../static/voice-play.gif':'../../static/voice.png'"
                                                alt=""
                                            />
                                            <span> "</span>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li v-else-if="item.opercode==2002" class="chatanswer">
                                <div class="avatr"><img src="../../../static/head.svg" alt=""></div>
                                <div >
                                    <!-- {{}} -->
                                    <p v-if="item.addtime">{{item.addtime | showDate}}</p>
                                    <!-- <p v-else>{{item.time | showDate}}</p> -->
                                    <div v-if="item.MsgType=='text'" class="chattext">
                                        {{item.content}}
                                    </div>
                                    <div v-if="item.MsgType=='image'" class="chattext">
                                         <img @click="tobig(item.PicUrl)" v-viewer="{movable: false}" class="pictur" :src="item.PicUrl" alt="">
                                    </div>
                                </div>
                            </li>
                        </div>
                    
                    </ul>

                    <a-empty :description="des" v-else />

                </div>
                <div class="bottom">
                    <div class="toolbox">
                        <a-upload
                            name="file"
                            action="/api/wechat/addimg"
                            @change="uploadimg"
                            :headers="headers"
                            :show-upload-list="false"
                        >
                            <a-icon type="picture" />
                        </a-upload>
                    </div>
                    <div class="content">
                        <div class="input-panel" style="height:80px" ref="msgInputContainer" @keydown.enter="keyDown" contenteditable="true" spellcheck="false" ></div>
                        <!-- <textarea  @keydown.enter="keyDown" v-model="answer" rows="3"></textarea> -->
                    </div>
                    <div class="button">
                        <a-button @click="tosend" :disabled="nickname ? false:true" type="primary">发送</a-button>

                         <!-- <a-button @click="tosend"  type="primary">发送</a-button> -->
                    </div>
                </div>
            </div>
            <div class="chatlist">
                <div class="topinfo">
                    <h2>{{item_title}}</h2>
                    <p class="name"><a-badge v-if="status_kf==1" status="success" /><a-badge v-if="status_kf==0" status="orange" />{{name}} 
                        <a-dropdown>
                            <a v-if="status_kf==1" class="ant-dropdown-link" @click="e => e.preventDefault()">在线
                             <a-icon type="down" />
                            </a>
                             <a v-if="status_kf==0" class="ant-dropdown-link" @click="e => e.preventDefault()">离线
                             <a-icon type="down" />
                            </a>
                            <a-menu slot="overlay"  @click="onClick">
                                <a-menu-item key="1">
                                    <a href="javascript:;">在线</a>
                                </a-menu-item>
                                <a-menu-item key="0">
                                    <a href="javascript:;">离线</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </p>
                     
                </div>
                <div class="numinfo">
                    <span v-if="num">接入客户：{{num}}人</span> 
                    <span v-else>接入客户：0人</span> 
                    <!-- <span>在线客服：3人</span>  -->
                </div>
                <div class="list"> 
                    <a-tabs default-active-key="1" @change="callback">
                        <a-tab-pane key="1" tab="当前会话">
                            <div v-if="khlist.length!=0">
                                <div class="listinfo" v-for="item in khlist" :key="item.uswxlid" @click="getchatlist(item.openid,item.nickname,item.headimgurl)">
                                    <img :src="item.headimgurl" alt="">
                                    <div>
                                        <h3>{{item.nickname}} <span v-if="item.num !=0" style="font-size:14px;color:#f50">未读{{item.num}}条</span></h3>
                                        <p v-if="item.status==0">
                                            <a-tag color="orange">待接入</a-tag>
                                        </p>
                                        <p v-if="item.status==1">
                                            <a-tag color="blue">会话中</a-tag>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <a-empty :description="des" v-else />
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="已结束会话" force-render>
                            <div v-if="khlist.length!=0">
                                 <div  class="listinfo"  v-for="item in khlist" :key="item.uswxlid"  @click="getchatedlist(item.openid,item.nickname,item.headimgurl)">
                                    <img :src="item.headimgurl" alt="">
                                    <div>
                                        <h3>{{item.nickname}}</h3>
                                        <p v-if="item.status==2">
                                            <a-tag color="orange">会话结束</a-tag>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <a-empty :description="des" v-else />
                           
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
        </div>

       

    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import { Modal } from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment'
import BenzAMRRecorder from 'benz-amr-recorder'
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      },

       showDate(time){
          time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    data(){
        return{
            chat:[
                {content:"嗨，你好！这是一条测试内容。",type:0},
                {img:"../../../static/head.svg",type:0},
                {content:"嗨，你好",type:1},
            ],

            answer:"",
            photo:[],
            aid:"",
            name:"",
            item_title:"",
            room_id:"",
            token:"",
            ws:{},
            status:1,

            khlist:"",
            chatloglist:"",
            des:"暂无会话",
            nickname:"",

            websock: null,
            openid:"",
            num:"",

            client_id:"",
            status_kf:"1",
            headimgurl:"",

            khinfo:"",

            videosrc:"./static/1.amr",

            timer: null,
            isPlaying: false,
            duration:"",

            headers:{
                "token":localStorage.getItem('token')
            },
            imid:""

        }
    },
    created(){
        //页面刚进入时开启长连接
        this.personinfo()

    },
    destroyed: function() {
        //页面销毁时关闭长连接
        this.connect()
        this.status_kf=0
        this.updatekf()
    },
    mounted(){
        // this.personinfo()
        this.token=localStorage.getItem("token")
        var t
        var that=this
        clearTimeout(t)
        t = setTimeout(function (){
            that.updatekf()
            // that.editkf()
            that.flush_client_list()
       },800)
    },
    
    updated(){
        // 聊天定位到底部
        let ele = document.getElementById('chatRecord');
        ele.scrollTop = ele.scrollHeight;
    },
    methods:{

        // 上传图片
        uploadimg({ file, fileList }){
            console.log(file)
            this.imgFile=file.response.data.path
            this.imgurl=file.response.data.url
            const imgTag = document.createElement("img");
            imgTag.src = this.imgurl;
            imgTag.alt=this.imgFile
            this.$refs.msgInputContainer.appendChild(imgTag);
            
        },

        toplay(url,i){
            // let vm = this
            // vm.stopPlayVoice()
            var amr = new BenzAMRRecorder();    //创建
            var that=this
            amr.initWithUrl(url).then(function() {
                if (that.chatloglist[i].isPlaying===0) {
                    var duration=amr.getDuration(); 
                    that.duration=duration
                    amr.play();
                    that.chatloglist[i].isPlaying = 1;
                    that.watchEnd(i);
                }else{
                    amr.stop();
                    clearTimeout(that.timer);
                    that.chatloglist[i].isPlaying = 0;
                }
            });
            
        },

        watchEnd(i) {
            let that = this;
            this.timer = setTimeout(() => {
            that.chatloglist[i].isPlaying = 0;
            }, (that.duration + 1) * 1000);
        },
        // editkf(){

        // },
        onClick({ key }){
            if(key==0){
                this.status_kf=0
                this.updatekf()
            }else if(key==1){
                this.status_kf=1
                this.updatekf()
            }   
        },
        keyDown(){
          this.tosend()  
        },
        updatekf(){
            this.$axios.post('/api/system/editadmin',{
                aid:this.aid,
                status_kf:this.status_kf,
                client_id:this.client_id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                
                if(res.data.code==200){
                    // this.item_title=res.data.data.item_title
                    // this.name=res.data.data.name
                    // this.aid=res.data.data.aid
                    // this.room_id=res.data.data.aid     
                    // this.connect()                
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        },
        callback(key){
            if(key==1){
                this.status=1
                this.answer=""
                this.flush_client_list()
            }else if(key==2){
                this.status=2
                this.answer=""
                this.flush_client_list()
            }
        },
        personinfo(){

            this.$axios.post('/api/system/adminpage',{
                },{
                    headers: {
                        "token":localStorage.getItem('token'),
                    }
                }).then((res)=>{
                    
                    if(res.data.code==200){
         
                        this.name=res.data.data.name
                        this.aid=res.data.data.aid
                        this.room_id=res.data.data.aid
                        this.imid=res.data.data.imid    
                        this.connect()                
                    }else{
                        this.$message.warning(res.data.msg); 
                    }
                    
                })
        },
        getchatedlist(id,name,headimgurl){
            this.openid=id
            this.nickname=name
            this.headimgurl=headimgurl
            this.getkhinfo(id)
            this.flush_client_list()
            this.$axios.post('/api/wechat1/chatlog',{
                openid:id,
                aid:this.aid,
                size:200
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.chatloglist=res.data.data.data.reverse()
            
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        // 获取聊天列表/更改状态
        getchatlist(id,name,headimgurl){
            this.openid=id
            this.nickname=name
            this.headimgurl=headimgurl
            this.getkhinfo(id)
            this.$axios.post('/api/wechat1/edituserwxislt',{
                openid:id,
                status:1,
                num:0,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.flush_client_list()
                    this.$axios.post('/api/wechat1/chatlog',{
                        openid:id,
                        aid:this.aid,
                        size:200
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.chatloglist=res.data.data.data.reverse()
                    
                        }else{
                            this.$message.warning(res.data.msg); 
                        }
                    })
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        // 获取客户信息
        getkhinfo(id){
            this.$axios.post('/api/wechat1/consultingservice',{
                openid:id,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.khinfo=res.data.data
                }else{
                    this.khinfo=""
                    // this.$message.warning(res.data.msg); 
                }
            })
        },
        // 图片预览
        tobig(src){
            // this.photo.push(src)
            const viewer = this.$el.querySelector('.pictur').$viewer
            viewer.show()
        },
        connect(){

             // 创建websocket
            // this.ws = new WebSocket("ws://fxbsocket.13524.net:7272");
            this.ws = new WebSocket("wss://fxbsocket.13524.net/wss");
            // 当socket连接打开时，输入用户名
            this.ws.onopen = this.onopen;
            // 当有消息时根据消息类型显示不同信息
            this.ws.onmessage = this.onmessage; 

            // this.ws.onclose = function() {
            //     console.log("连接关闭，定时重连");
            //     var that=this
            //     that.connect;//重新连接
            // };

            this.ws.onclose=this.connect
            this.ws.onerror = function() {
                this.$message.warning("连接错误"); 
                console.log("出现错误");
            };
        },

        onopen()
        {
            // 登录
            var login_data = '{"type":"login","client_name":"'+this.name+'","room_id":"'+this.room_id+'","aid":"'+this.aid+'","token":"'+this.token+'"}';
            console.log("websocket握手成功，发送登录数据:"+login_data);
            var data=JSON.parse(login_data)
            this.client_id=data.client_id
            var that=this
            if(that.ws.readyState==1){
                that.ws.send(login_data)  
            }
                
            // that.updatekf()
        
        },

        onmessage(e){
            console.log(e.data);
            var data = JSON.parse(e.data);
            if(data.type=="ping"){
                this.ws.send('{"type":"pong"}');
                return false
            }else if(data.type=="login"){
                var client_id =  data['client_id'];
                var client_name = data['client_name'];
                var time = data['time'];
                this.say(data['client_id'], client_name,  '欢迎————'+client_name+' 加入了聊天室', time);
                
                //获取在线咨询的客户
                this.flush_client_list(this.aid,this.token);
                console.log(data['client_name']+"登录成功");
                return false
            }else if(data.type=="say"){
                this.flush_client_list()
                this.say(data);
                this.status=1

                return false
            }
        },

        say(data){
            console.log(this.openid)
            console.log(data)
            if(data.openid==this.openid){
                if(this.chatloglist){
                    this.chatloglist.push(data)
                } 
            }else{

                for (var i in this.khlist){
                    console.log("=="+this.khlist[i].openid)
                    if(this.khlist[i].openid==data.openid){
                         console.log(11111)
                         var num=parseInt(this.khlist[i].num)+1
                         console.log("num="+num)
                        this.$axios.post('/api/wechat1/edituserwxislt',{
                            openid:data.openid,
                            num:num,
                            status:1,
                        },{
                            headers: {
                                "token":localStorage.getItem('token'),
                            }
                        }).then((res)=>{
                            if(res.data.code==200){
                                this.flush_client_list()
                            }
                        })
                        
                    }
                }
                // console.log(this.khlist)
                // this.wdnum++
            }
            // this.
            // if(this.chatloglist){
            //     this.chatloglist.push(data)
            // }
            
            // console.log(this.chatloglist)
        },

        flush_client_list(){
             this.$axios.post('/api/wechat1/userwxislt',{
                aid:this.aid,
                status:this.status,
                size:50
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.khlist=res.data.data.data
                    if(this.status==1){
                        this.num=this.khlist.length
                    }
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // getnum(){

        // },
        

        // 发送信息
        tosend(){
            var j=0
            this.answer=this.$refs.msgInputContainer.innerText
            var imglit=this.$refs.msgInputContainer.querySelectorAll('img')
            console.log(imglit)
            for(var i in imglit){
                this.$axios.post('/api/wechat/setguideimagematerialupload',{
                    path:imglit[i].alt,
                    imid:this.imid,
                    url:imglit[i].src

                },{
                    headers: {
                        "token":localStorage.getItem('token'),
                    }  
                }).then((res)=>{
                    if(res.data.media_id){
                        this.$axios.post('/api/wechat/sendMessage',{
                            aid:this.aid,
                            media_id:res.data.media_id,
                            openid:this.openid,
                            MsgType:"image"
                        },{
                            headers: {
                                "token":localStorage.getItem('token'),
                            }
                        }).then((res)=>{
                            var data=JSON.parse(res.data)
                            if(data.errcode==0){
                                this.$refs.msgInputContainer.innerHTML=""
                                this.$axios.post('/api/wechat1/chatlog',{
                                    openid:this.openid,
                                    aid:this.aid,
                                    size:200
                                },{
                                    headers: {
                                        "token":localStorage.getItem('token'),
                                    }
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        this.chatloglist=res.data.data.data.reverse()
                                    }else{
                                        this.$message.warning(res.data.msg); 
                                    }
                                })
                            }else{
                                this.$message.warning(data.errmsg); 
                            }
                        
                        })
                    }else{
                        // this.$message.error(res.data.msg);
                    }
                })
            }

            if(this.answer){
                this.$axios.post('/api/wechat/sendMessage',{
                    aid:this.aid,
                    content:this.answer,
                    openid:this.openid,
                    MsgType:"text"
                },{
                    headers: {
                        "token":localStorage.getItem('token'),
                    }
                }).then((res)=>{
                    var data=JSON.parse(res.data)
                    console.log(data)
                    if(data.errcode==0){
                        this.answer=""
                        this.$refs.msgInputContainer.innerHTML=""
                        this.$axios.post('/api/wechat1/chatlog',{
                            openid:this.openid,
                            aid:this.aid,
                            size:200
                        },{
                            headers: {
                                "token":localStorage.getItem('token'),
                            }
                        }).then((res)=>{
                            if(res.data.code==200){
                                this.chatloglist=res.data.data.data.reverse()
                            }else{
                                this.$message.warning(res.data.msg); 
                            }
                        })
                    }else{
                        this.$message.warning(data.errmsg); 
                    }
                
                })
            }

            
            

            // console.log(this.answer)
            // this.$axios.post('/api/wechat/sendMessage',{
            //     aid:this.aid,
            //     content:this.answer,
            //     openid:this.openid,
            //     MsgType:"text"
            // },{
            //     headers: {
            //         "token":localStorage.getItem('token'),
            //     }
            // }).then((res)=>{
            //     var data=JSON.parse(res.data)
            //     console.log(data)
            //     if(data.errcode==0){
            //         this.answer=""
            //         this.$axios.post('/api/wechat1/chatlog',{
            //             openid:this.openid,
            //             aid:this.aid,
            //             size:200
            //         },{
            //             headers: {
            //                 "token":localStorage.getItem('token'),
            //             }
            //         }).then((res)=>{
            //             if(res.data.code==200){
            //                 this.chatloglist=res.data.data.data.reverse()
            //             }else{
            //                 this.$message.warning(res.data.msg); 
            //             }
            //         })
            //     }else{
            //         this.$message.warning(data.errmsg); 
            //     }
               
            // })
            // this.chat.push()
        },
    }
}
</script>
<style>
/* main{height: 100%;overflow-y: hidden;} */
</style>


// WEBPACK FOOTER //
// src/components/chat/chatpage.vue